import { useEffect, useState } from "react";
import { Modal, Button, Loader } from "@mantine/core";

const LoadingModal = ({
  loadingOpen,
  setLoadingOpen,
  loadingPrompt,
  setLoadingPrompt,
  setOpened,
}) => {
  const [doneEdit, setDoneEdit] = useState(false);
  const [buttonPrompt, setButtonPrompt] = useState("Close");
  const [successUpdate, setSuccessUpdate] = useState(false);
  const [interruptedUpdate, setInterruptedUpdate] = useState(false);
  //   const [errorMessage, setErrorMessage] = useState('');
  // useEffect(() => {
  //   if (updateState.status === 'Exception') {
  //     setInterruptedUpdate(true);
  //     setButtonPrompt('Try Again');
  //   } else if (updateState.status === 'Success') {
  //     setSuccessUpdate(true);
  //     setDoneEdit(true);
  //     setButtonPrompt('Close');
  //   }
  //   //eslint-disable-next-line
  // }, [updateState]);

  // depending on prompt, set button prompt
  useEffect(() => {
    if (loadingPrompt === "Success") {
      setSuccessUpdate(true);
      setDoneEdit(true);
      setButtonPrompt("Close");
    }
    if (loadingPrompt === "Error") {
      setInterruptedUpdate(true);
      setDoneEdit(true);
      setButtonPrompt("Try Again");
    }
  }, [loadingPrompt, setLoadingPrompt]);
  const customLoader = (
    <div
      className={
        doneEdit ? "hidden flex-col items-center" : "flex flex-col items-center"
      }
    >
      <Loader color={"#ADB5FF"} />
      <p className="mt-5">{loadingPrompt}</p>
    </div>
  );

  // if success, show close button and return out of modal and close modal
  // if interrupted, show try again button and return out of modal but not close modal
  const closeModal = () => {
    if (buttonPrompt === "Close") {
      setLoadingPrompt("");
      setDoneEdit(false);
      setSuccessUpdate(false);
      setInterruptedUpdate(false);
      setLoadingOpen(false);
      setOpened(false);
    } else if (buttonPrompt === "Try Again") {
      setLoadingPrompt("");
      setDoneEdit(false);
      setSuccessUpdate(false);
      setInterruptedUpdate(false);
      setLoadingOpen(false);
    }
  };
  return (
    <>
      <Modal
        opened={loadingOpen}
        closeOnClickOutside={false}
        onClose={closeModal}
        withCloseButton={false}
        centered={true}
        padding={"60px 30px"}
        styles={{
          modal: {
            textAlign: "center",
            borderRadius: "10px",
            padding: "20px",
            width: "300px",
          },
        }}
      >
        {/* <LoadingOverlay
          loader={customLoader}
          overlayOpacity={0.3}
          overlayColor="#ADB5FF"
          visible={overlay}
        /> */}
        {customLoader}
        <div>
          {successUpdate && (
            <div className="flex flex-col items-center justify-center ">
              <img
                className="mb-5 h-20 w-20"
                src={"/airdrop_assets/confirmpage_check.png"}
                alt="Confirm"
              ></img>
              <div>
                <p>Changes Successfully Saved </p>
              </div>
            </div>
          )}
        </div>
        <div>
          {interruptedUpdate && (
            <div className="flex flex-col items-center justify-center ">
              <img
                className="mb-5 h-20 w-20"
                src={"/airdrop_assets/warning.png"}
                alt="Warning"
              ></img>
              <div>
                <p>We weren&apos;t able to save your changes</p>
              </div>
            </div>
          )}
        </div>
        <Button
          className={
            doneEdit
              ? "btn-pri mx-auto mt-10 block w-44 px-12 hover:bg-bgv2"
              : "btn-pri mx-auto mt-10 hidden px-12 hover:bg-bgv2"
          }
          onClick={closeModal}
        >
          <span>{buttonPrompt}</span>
        </Button>
      </Modal>
    </>
  );
};

export default LoadingModal;
